import { render } from "./ManagerSettings.vue?vue&type=template&id=3ff9971a"
import script from "./ManagerSettings.vue?vue&type=script&lang=js"
export * from "./ManagerSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__